import classNames from "classnames";
import { CheckGlyph, IndeterminateGlyph } from "./CheckboxGlyphs";
import styles from "./Checkbox.module.scss";

export type CheckboxIndicatorState = "checked" | "unchecked" | "indeterminate";

interface CheckboxIndicatorProps {
    state: CheckboxIndicatorState;
    disabled?: boolean;
    className?: string;
}

// Purely decorative: the owning control (option row, button) carries the
// checked semantics; this only paints the design-system checkbox visual.
export const CheckboxIndicator = ({
    state,
    disabled = false,
    className,
}: Readonly<CheckboxIndicatorProps>) => (
    <span
        aria-hidden="true"
        className={classNames(styles.checkbox, className)}
        data-checked={state === "checked" ? "" : undefined}
        data-indeterminate={state === "indeterminate" ? "" : undefined}
        data-disabled={disabled ? "" : undefined}
    >
        <span className={styles.control}>
            {state !== "unchecked" && (
                <span className={styles.glyph}>
                    <CheckGlyph className={styles.checkGlyph} />
                    <IndeterminateGlyph className={styles.indeterminateGlyph} />
                </span>
            )}
        </span>
    </span>
);
